module.exports = __webpack_public_path__ + "img/carlando3.f40f41af.jpg";